<template>
  <v-card>
    <v-toolbar dark color="primary" tile flat class="mb-5">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('absence.listTitle') }}</v-toolbar-title>
    </v-toolbar>

    <v-list v-for="(absence, index) in chatsAbsence" :key="`${index}-absence`" class="">
      <v-list-item>
          <div class="mb-3">{{ absence.child.lastName }} {{ absence.child.firstName }}</div>
          <div class="mb-3">{{ $t('absence.reason') }}：{{ showReason(absence.detail.reason) }}</div>
          <template v-if="absence.detail.reason === 'others'">
            <div class="mb-3">
              {{ absence.detail.comment }}
            </div>
          </template>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>

    <div class="ml-4" v-if="chatsAbsence.length === 0">
      {{ $t('absence.noAbsences') }}
    </div>
  </v-card>
</template>
<script lang="ts">
//import Vue, { PropType } from 'vue';
import { defineComponent, PropType } from "vue";
import dayjs from 'dayjs';
import {
  AbsenceReason,
  AbsenceReasonType,
} from 'chaild-api/lib';
import { when } from '@/service/Switch';

// model
import { VForm } from '@/model/Vuetify/VForm';
import { NurseryAttendanceResponse } from 'chaild-api/lib';
import { AbsenceChildType } from '@/model/Response';

interface DataType {
  absenceId: number;
}

export default defineComponent({
  name: 'AbsenceModal',

  props: {
    chatsAbsence: {
      type: Array as PropType<AbsenceChildType[]>,
      default: [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  computed: {},

  data: (): DataType => ({
    absenceId: NaN,
  }),

  watch: {
    deleteDialog: {
      async handler(val: boolean) {
        if (!val) {
          this.absenceId = NaN;
        }
      },
      deep: true,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
    showReason(reason: AbsenceReasonType): string {
      const temp = when(reason)
        .on(
          v => v === AbsenceReason.fever,
          () => (this as any).$t('absenceReason.fever')
        )
        .on(
          v => v === AbsenceReason.personal,
          () => (this as any).$t('absenceReason.personal')
        )
        .on(
          v => v === AbsenceReason.infStrep,
          () => (this as any).$t('absenceReason.infStrep')
        )
        .on(
          v => v === AbsenceReason.infMycoplasma,
          () => (this as any).$t('absenceReason.infMycoplasma')
        )
        .on(
          v => v === AbsenceReason.infHFMD,
          () => (this as any).$t('absenceReason.infHFMD')
        )
        .on(
          v => v === AbsenceReason.infSlappedCheek,
          () => (this as any).$t('absenceReason.infSlappedCheek')
        )
        .on(
          v => v === AbsenceReason.infStomach,
          () => (this as any).$t('absenceReason.infStomach')
        )
        .on(
          v => v === AbsenceReason.infHerpangina,
          () => (this as any).$t('absenceReason.infHerpangina')
        )
        .on(
          v => v === AbsenceReason.infRS,
          () => (this as any).$t('absenceReason.infRS')
        )
        .on(
          v => v === AbsenceReason.infZoster,
          () => (this as any).$t('absenceReason.infZoster')
        )
        .on(
          v => v === AbsenceReason.infRoseola,
          () => (this as any).$t('absenceReason.infRoseola')
        )
        .on(
          v => v === AbsenceReason.infImpetigo,
          () => (this as any).$t('absenceReason.infImpetigo')
        )
        .on(
          v => v === AbsenceReason.covid19,
          () => (this as any).$t('absenceReason.covid19')
        )
        .on(
          v => v === AbsenceReason.others,
          () => (this as any).$t('absenceReason.others')
        )
        .otherwise(() => '');
      return temp;
    },
  },

  async mounted() {},
});
</script>
<style lang="scss" scoped>
.delete-absence-dialog {
  z-index: 20 !important;
}
</style>
